const initialState = {
    data: null,
};
export const DeleteMoreThanOneSharedDocumentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DELETEMORETHANONE_SHAREDDOCUMENT_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'DELETEMORETHANONE_SHAREDDOCUMENT_FAILURE':
            return {
                ...state,
                error: action.payload,
            };
        case 'DELETEMORETHANONE_SHAREDDOCUMENT_RESET':
            return initialState;
        default:
            return state;
    }
}

export default DeleteMoreThanOneSharedDocumentReducer;